import React from 'react';
import './ContactFAB.css';

let ContactFAB = props => {
    return (
        <div id="contact-fab">
            <a href="tel:+919779169788">
                <div className="contact-fab-item">
                    <i className="main-icon fas fa-1x fa-phone-square-alt"/>
                    <div className="fab-hint">
                        <i className="fas fa-1x fa-phone-square-alt"/>
                        <p className="fab-hint-label">Make a call</p>
                    </div>
                </div>
            </a>
            <a href="mailto:info@audigosolutions.com">
                <div className="contact-fab-item">
                    <i className="main-icon fas fa-1x fa-envelope"/>
                    <div className="fab-hint">
                        <i className="fas fa-1x fa-envelope"/>
                        <p className="fab-hint-label">Send a mail</p>
                    </div>
                </div>
            </a>
            <a href="https://www.google.com/maps/place/Audigo+Global+Solutions/@13.0020374,77.5414205,15z/data=!4m5!3m4!1s0x0:0x6796da8583ec6f50!8m2!3d13.0020374!4d77.5414205" target="_blank">
                <div className="contact-fab-item">
                    <i className="main-icon fas fa-1x fa-map-marker-alt"/>
                    <div className="fab-hint">
                        <i className="fas fa-1x fa-map-marker-alt"/>
                        <p className="fab-hint-label">Open Geo-location</p>
                    </div>
                </div>
            </a>
        </div>
    );
};

export default ContactFAB;


// WEBPACK FOOTER //
// ./src/Components/ContactFAB/ContactFAB.js